import { render } from "./PeerWithMe.vue?vue&type=template&id=1930f193"
import script from "./PeerWithMe.vue?vue&type=script&lang=js"
export * from "./PeerWithMe.vue?vue&type=script&lang=js"

import "./PeerWithMe.vue?vue&type=style&index=0&id=1930f193&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__